
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'middleware'
})
export default class extends Vue {
  private menus = this.$store.state.permission.menu
  mounted () {
    if (this.menus.length > 0) {
      const path = this.menus[0].path
      const childPath = this.menus[0].children[0].path
      const jointPath = `${path + '/' + childPath}`
      this.$router.push({ path: jointPath })
    } else {
      this.$router.push('/enterpriseApp')
    }
  }
}
